import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { UploadFileData } from 'src/app/Models/master';
import { NotificationService } from 'src/app/Services/notification.service';
import { TransactionService } from 'src/app/Services/transaction.service';
import { UploadFilesService } from 'src/app/Services/upload.service';
import { Utility } from 'src/app/Utilities/utility';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-multiple-file-upload',
  templateUrl: './multiple-file-upload.component.html',
  styleUrls: ['./multiple-file-upload.component.css']
})
export class MultipleFileUploadComponent implements OnInit {
  utility: Utility;
  progressInfos: any[] = [];
  message = '';
  mode: string = 'I';
  SpraId:number = 0;
  //Added By rahul yadav on 15/7/2021 in case of view
  FromView:boolean=false;
  public IsFromApprovedlist:boolean = false;

  fileInfos?: Observable<any>;
  UploadFileData: Array<UploadFileData>;
  UploadFileName: any[] = [];

  constructor(private uploadService: UploadFilesService,
    private transactionService: TransactionService,
    private _NotificationService: NotificationService,
    private _CookieService: CookieService,
    private dialog: MatDialog
  ) {
    this.utility = new Utility(this._CookieService);
    this.UploadFileData = new Array<UploadFileData>();
    this.UploadFileData.push(new UploadFileData());
    // this.mode = 'I';
  }
  ngOnInit(): void {
  }


  selectFiles(uploadFile: UploadFileData, event: any, index: number): void {
    // debugger
    if(!this.utility.IsFileSizeValid(event.target.files[0].size)){
      this._NotificationService.showError("Uploaded Document size should be less then 2MB.", "Document");
    }else if(!this.utility.IsFileTypeValid(event.target.files[0].type)){
      this._NotificationService.showError("Uploaded Document should be PDF Only.", "Document");
    }else{
      this.progressInfos = [];
      uploadFile.File = event.target.files[0];    
      this.addRow(uploadFile, index);
    }
    
  }


  // Upload document code if required
  // UploadDocuments(): void {
  //   let UploadFileName:any[] = [];
  // if(this.UploadFileData != undefined){  
  //   for (let i = 0; i < this.UploadFileData.length; i++) {
  //     let uploadFileData:UploadFileData  = this.UploadFileData[i];
  //     if(uploadFileData.File != undefined){
  //       let progressInfoObj = { "value": 0, "fileName": uploadFileData.File.name };
  //       this.progressInfos.push(progressInfoObj);    
  //       this.uploadService.upload(uploadFileData).subscribe(
  //         event => {
  //           if(event){
  //             let dt:any = event;
  //             if(dt.body != undefined){
  //               UploadFileName.push({"fileName":dt.body.fileName,"purpose": dt.body.purpose});           
  //              if(UploadFileName.length == this.UploadFileData.filter((f)=>{return f.File != undefined }).length){


  //              }           

  //             }

  //             if (event.type === HttpEventType.UploadProgress && event.total != undefined) {
  //               this.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
  //             } 

  //           }            

  //         },
  //         err => {
  //           this.progressInfos[i].value = 0;
  //         });

  //     }

  //   }
  // }
  // }




  addRow(uploadFile: UploadFileData, index: number) {
    // debugger
    if (index == 0 || index == this.UploadFileData.length - 1) {
      uploadFile.IsNewRow = true;
      this.UploadFileData.push(new UploadFileData());
      return true;
    } else {
      return false;
    }

  }

  deleteRow(index: number, uploadFileData: UploadFileData) {
  // debugger
  if(this.IsFromApprovedlist){
    this.deleteDocument(index, uploadFileData);
  }else{
    if (uploadFileData.disable) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '50%',
        data: {
          "Title": "Confirmation",
          "Message": "Are you sure ! You want to delete upload document."
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.data.IsConfirmed) {

            this.uploadService.DeleteFile(uploadFileData.DownloadFilePath).subscribe((d)=>{
              if(d){
                

                let DocumentsToUpdate:any[] = []
                let dt:UploadFileData[] =  this.UploadFileData.filter((ft)=>{ return ft.DownloadFilePath != ""});
                dt.forEach((t,index)=>{
                  if(t.DownloadFilePath != ""){
                    if(t.DownloadFilePath != uploadFileData.DownloadFilePath){
                      let doc:any=  {"fileName":t.DownloadFilePath,purpose:t.Purpose}
                      DocumentsToUpdate.push(doc);
                    }
                    
                    if(index== dt.length-1){
                      this.transactionService.UpdateSPRADocumentById(this.SpraId,JSON.stringify(DocumentsToUpdate)).subscribe((dt)=>{
                        if(dt){
                          this.deleteDocument(index, uploadFileData);
                        }
                      });

                    }
                  }
                });


                
                


              }
            });



            
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
    } else {
      this.deleteDocument(index, uploadFileData);
    }
  }
}


  deleteDocument(index: number, uploadFileData: UploadFileData) {
    this.progressInfos = [];
    if (this.UploadFileData.length == 1) {
      return false;
    } else {
      this.UploadFileData.splice(index, 1);
      return true;
    }
  }

  Validation(): boolean {
    let IsDocumentSelected: boolean = false;
    let IsUploadDocumentValid: boolean = true;
    for (let i = 0; i < this.UploadFileData.length; i++) {
      if (this.UploadFileData[i].File != undefined || this.UploadFileData[i].DownloadFilePath != "") {
        IsDocumentSelected = true;
        if (!this.utility.CheckStringRequired(this.UploadFileData[i].Purpose) && IsUploadDocumentValid) {
          this._NotificationService.showError("Please enter uploaded documents purpose.", "Document");
          IsUploadDocumentValid = false;
        }
      }
    }

    //commented by rahul yadav on 27/05/2021 to remove mandatory check from document upload     
    // if (!IsDocumentSelected) {
    //   this._NotificationService.showError("Please select at least on Document", "Document");
    //   return false;
    if (!IsUploadDocumentValid) {
      return false;
    } else {
      return true;
    }

 
  }


  Download(uploadFileData: UploadFileData) {
    // uploadFileData.DownloadFilePath
      this.uploadService.DownloadFile(uploadFileData.DownloadFilePath).subscribe((d: any) => {
        var blob = new Blob([d]);  
          let file = uploadFileData.DownloadFilePath;  
          saveAs(blob, file); 

        // const blob = new Blob([d]);
        // const url= window.URL.createObjectURL(blob);
        // window.open(url);
         
        });;


  }




}
